module.exports = __webpack_public_path__ + "img/formats-5.80f07c4b.png";